import * as types from '../mutation-types'

//建议对于getters,actions都加上模块名
// initial state
const state = {
  params: null
}

// getters
const getters = {
  tabpanel_params: state => state.params 
}

// actions
const actions = {
  tabpanelBuildParams ({ commit, state }, params_) {
    commit(types.TABPANEL_BUILD_PARAMS, params_);
  },
}

// mutations
const mutations = {
  //开启关闭左边菜单
  [types.TABPANEL_BUILD_PARAMS] (state, params_) {
      state.params = params_;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/tabpanel.js